export default "__VITE_ASSET__7258dd1b__"